import React from "react";
import * as c from "./author.module.scss";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames";

export const Author = ({ className, size = "sm", children }) => (
  <figure className={classNames(className, c.container, c[size])}>{children}</figure>
);

Author.photo = ({ className, photo, alt }) => (
  <GatsbyImage className={classNames(className, c.photo)} image={getImage(photo)} alt={alt} />
);

Author.caption = ({ className, children }) => (
  <figcaption className={classNames(className, c.caption)}>{children}</figcaption>
);
